// src/components/Sections/HeroSection/HeroSection.jsx

import React from 'react';
import './HeroSection.scss';

import homeScreenshot from '../../../assets/images/marketing/ttg-home-dashboard-phone.png';
import groupScreenshot from '../../../assets/images/marketing/ttg-groups-phone.png';
import seriesScreenshot from '../../../assets/images/marketing/ttg-tour-series-phone.png';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="hero-v4 hero-v4--animated"
    >
      {/* =====================================================
          BACKGROUND GLOW
          ===================================================== */}

      <div
        className="hero-v4__glow"
        aria-hidden="true"
      ></div>

      {/* =====================================================
          COURSE ROUTE
          ===================================================== */}

      <div
        className="hero-v4__course-line"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 900 600"
          role="presentation"
        >
          {/* Faint course edge */}

          <path
            className="hero-v4__course-line-edge"
            d="
              M42 530
              C 127 462,
              177 480,
              252 416
              S 344 349,
              423 309
              S 538 237,
              608 163
              S 725 89,
              842 70
            "
          />

          {/* Faint route underneath */}

          <path
            className="hero-v4__route-base"
            d="
              M62 512
              C 132 455,
              185 459,
              242 398
              S 330 327,
              407 292
              S 523 221,
              592 145
              S 714 70,
              824 55
            "
          />

          {/* Animated route */}

          <path
            className="hero-v4__route-progress"
            pathLength="1"
            d="
              M62 512
              C 132 455,
              185 459,
              242 398
              S 330 327,
              407 292
              S 523 221,
              592 145
              S 714 70,
              824 55
            "
          />

          {/* Route markers */}

          <circle
            className="hero-v4__route-marker hero-v4__route-marker--1"
            cx="62"
            cy="512"
            r="7"
          />

          <circle
            className="hero-v4__route-marker hero-v4__route-marker--2"
            cx="407"
            cy="292"
            r="6"
          />

          <circle
            className="hero-v4__route-marker hero-v4__route-marker--3"
            cx="592"
            cy="145"
            r="6"
          />

          <circle
            className="hero-v4__route-marker hero-v4__route-marker--4"
            cx="824"
            cy="55"
            r="10"
          />

          {/* Yardages */}

          <text
            className="hero-v4__route-label hero-v4__route-label--1"
            x="78"
            y="505"
          >
            TEE
          </text>

          <text
            className="hero-v4__route-label hero-v4__route-label--2"
            x="425"
            y="285"
          >
            210
          </text>

          <text
            className="hero-v4__route-label hero-v4__route-label--3"
            x="610"
            y="138"
          >
            112
          </text>

          <text
            className="hero-v4__route-label hero-v4__route-label--4"
            x="720"
            y="37"
          >
            PAR 4 · 421 YDS
          </text>
        </svg>
      </div>

      {/* =====================================================
          CONTENT
          ===================================================== */}

      <div className="container hero-v4__inner">
        {/* ===================================================
            LEFT SIDE
            =================================================== */}

        <div className="hero-v4__copy">
          <p className="eyebrow eyebrow--light hero-v4__intro-reveal">
            The digital country club · GTA founding season 2027
          </p>

          <h1 className="hero-v4__title hero-v4__title-reveal">
            A country club

            <span>
              without walls.
            </span>
          </h1>

          <p className="hero-v4__lead hero-v4__lead-reveal">
            Keep score, compete with your regular foursome, and join
            season-long Tour Series. One membership connects the rounds
            you already play to the people who make golf worth playing.
          </p>

          <div className="hero-v4__actions hero-v4__actions-reveal">
            <a
              href="#contact"
              className="button button--cream"
            >
              Request Founding Membership
            </a>

            <a
              href="#how-it-works"
              className="text-link text-link--light"
            >
              See how The Tour works

              <span aria-hidden="true">
                ↓
              </span>
            </a>
          </div>

          <div className="hero-v4__proof hero-v4__proof-reveal">
            <div>
              <strong>
                90+
              </strong>

              <span>
                public courses mapped
              </span>
            </div>

            <div>
              <strong>
                iOS + Watch
              </strong>

              <span>
                app in testing
              </span>
            </div>

            <div>
              <strong>
                $39.99
              </strong>

              <span>
                CAD / year · at launch
              </span>
            </div>
          </div>
        </div>

        {/* ===================================================
            PRODUCT VISUAL
            =================================================== */}

        <div className="hero-v4__visual">
          <span
            className="
              hero-v4__ghost
              hero-v4__ghost--top
            "
            aria-hidden="true"
          >
            YOUR
          </span>

          <span
            className="
              hero-v4__ghost
              hero-v4__ghost--bottom
            "
            aria-hidden="true"
          >
            CLUB
          </span>

          {/* GROUPS */}

          <figure
            className="
              hero-v4__phone
              hero-v4__phone--group
            "
          >
            <img
              src={groupScreenshot}
              alt="The Tour Golfers group season standings"
              loading="eager"
            />
          </figure>

          {/* MEMBER DASHBOARD */}

          <figure
            className="
              hero-v4__phone
              hero-v4__phone--main
            "
          >
            <img
              src={homeScreenshot}
              alt="The Tour Golfers member dashboard"
              loading="eager"
            />
          </figure>

          {/* SERIES */}

          <figure
            className="
              hero-v4__phone
              hero-v4__phone--series
            "
          >
            <img
              src={seriesScreenshot}
              alt="The Tour Golfers Tour Series season progress"
              loading="eager"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}